import { Component, OnInit, ChangeDetectionStrategy, AfterViewInit, EventEmitter, Output } from '@angular/core';
import { TriggerEnum } from '../../models/trigger.enum';
import { ViewService } from 'src/app/view/view.service';

@Component({
  selector: 'app-view-tour-mobile',
  templateUrl: './view-tour-mobile.component.html',
  styleUrls: ['./view-tour-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewTourMobileComponent implements OnInit {

  triggers = TriggerEnum;

  constructor(private viewService: ViewService) { }

  ngOnInit() {
  }

  handleStartClick() {
    this.viewService.toggleTutorial(false);
  }

}
